module.exports = __webpack_public_path__ + "static/media/german_pezzella.c6b77d6d.jpg";